module.exports = __webpack_public_path__ + "img/avatar.d13a5ba2.jpeg";